/**
 * Comprehensive country code to currency mapping
 * Covers ~180+ countries for accurate currency detection
 * currency mappings should be reviewed periodically, especially for countries with volatile currencies
 */
export const countryToCurrencyMap = {
  // North America
  us: 'USD',
  ca: 'CAD',
  mx: 'MXN',
  as: 'USD', // American Samoa

  // Central America
  gt: 'GTQ',
  bz: 'BZD',
  sv: 'USD',
  hn: 'HNL',
  ni: 'NIO',
  cr: 'CRC',
  pa: 'PAB',

  // Caribbean
  cu: 'CUP',
  jm: 'JMD',
  ht: 'HTG',
  do: 'DOP',
  pr: 'USD',
  bs: 'BSD',
  bb: 'BBD',
  mq: 'EUR',
  gp: 'EUR',
  tt: 'TTD',
  cw: 'ANG',
  aw: 'AWG',
  bq: 'USD',
  sx: 'ANG',
  mf: 'EUR',
  bl: 'EUR',
  kn: 'XCD',
  lc: 'XCD',
  vi: 'USD',
  vc: 'XCD',
  vg: 'USD',
  ai: 'XCD',
  ag: 'XCD',
  dm: 'XCD',
  gd: 'XCD',
  ms: 'XCD',
  ky: 'KYD',
  tc: 'USD',

  // South America
  co: 'COP',
  pe: 'PEN',
  ve: 'VES',
  cl: 'CLP',
  ar: 'ARS',
  br: 'BRL',
  uy: 'UYU',
  py: 'PYG',
  bo: 'BOB',
  ec: 'USD',
  gy: 'GYD',
  sr: 'SRD',
  gf: 'EUR',
  fk: 'FKP',

  // Europe - Western
  gb: 'GBP',
  ie: 'EUR',
  fr: 'EUR',
  de: 'EUR',
  it: 'EUR',
  es: 'EUR',
  nl: 'EUR',
  be: 'EUR',
  lu: 'EUR',
  at: 'EUR',
  ch: 'CHF',
  li: 'CHF',
  mc: 'EUR',
  ad: 'EUR',
  gi: 'GIP',
  sm: 'EUR',
  va: 'EUR',

  // Europe - Northern
  se: 'SEK',
  no: 'NOK',
  dk: 'DKK',
  fi: 'EUR',
  ee: 'EUR',
  lv: 'EUR',
  lt: 'EUR',
  is: 'ISK',
  fo: 'DKK',
  sj: 'NOK',

  // Europe - Central & Eastern
  pl: 'PLN',
  cz: 'CZK',
  hu: 'HUF',
  ro: 'RON',
  bg: 'BGN',
  gr: 'EUR',
  pt: 'EUR',
  rs: 'RSD',
  hr: 'EUR',
  si: 'EUR',
  ba: 'BAM',
  mk: 'MKD',
  me: 'EUR',
  al: 'ALL',
  sk: 'EUR',
  mt: 'EUR',
  cy: 'EUR',
  md: 'MDL',

  // Europe - Eastern & Russia
  ru: 'RUB',
  ua: 'UAH',
  by: 'BYN',

  // Middle East
  ae: 'AED',
  sa: 'SAR',
  kw: 'KWD',
  qa: 'QAR',
  bh: 'BHD',
  om: 'OMR',
  ye: 'YER',
  iq: 'IQD',
  ir: 'IRR',
  il: 'ILS',
  jo: 'JOD',
  lb: 'LBP',
  sy: 'SYP',
  tr: 'TRY',

  // Central Asia
  kz: 'KZT',
  uz: 'UZS',
  kg: 'KGS',
  tj: 'TJS',
  tm: 'TMT',
  az: 'AZN',
  ge: 'GEL',
  am: 'AMD',

  // South Asia
  in: 'INR',
  pk: 'PKR',
  bd: 'BDT',
  lk: 'LKR',
  np: 'NPR',
  bt: 'BTN',
  mv: 'MVR',

  // Southeast Asia
  th: 'THB',
  id: 'IDR',
  ph: 'PHP',
  my: 'MYR',
  sg: 'SGD',
  vn: 'VND',
  kh: 'KHR',
  la: 'LAK',
  mm: 'MMK',
  bn: 'BND',
  tl: 'USD',

  // East Asia
  jp: 'JPY',
  cn: 'CNY',
  hk: 'HKD',
  mo: 'MOP',
  tw: 'TWD',
  kr: 'KRW',
  kp: 'KPW',
  mn: 'MNT',

  // Australia & Oceania
  au: 'AUD',
  nz: 'NZD',
  fj: 'FJD',
  to: 'TOP',
  ws: 'WST',
  nc: 'XPF',
  pg: 'PGK',
  sb: 'SBD',
  vu: 'VUV',
  ki: 'AUD',
  mh: 'USD',
  fm: 'USD',
  pw: 'USD',
  nr: 'AUD',
  tv: 'AUD',
  wf: 'XPF',
  pf: 'XPF',
  ck: 'NZD',
  nu: 'NZD',
  pn: 'NZD',
  nf: 'AUD',
  cx: 'AUD',
  cc: 'AUD',

  // Africa - North
  eg: 'EGP',
  ly: 'LYD',
  tn: 'TND',
  dz: 'DZD',
  ma: 'MAD',
  eh: 'MAD',

  // Africa - West
  ng: 'NGN',
  gh: 'GHS',
  ci: 'XOF',
  sn: 'XOF',
  ml: 'XOF',
  bf: 'XOF',
  ne: 'XOF',
  mr: 'MRU',
  gn: 'GNF',
  sl: 'SLL',
  lr: 'LRD',
  gm: 'GMD',
  gw: 'XOF',
  cv: 'CVE',
  st: 'STN',
  tg: 'XOF',
  bj: 'XOF',
  td: 'XAF',

  // Africa - Central
  cd: 'CDF',
  cg: 'XAF',
  cf: 'XAF',
  cm: 'XAF',
  gq: 'XAF',
  ga: 'XAF',
  ao: 'AOA',

  // Africa - East
  ke: 'KES',
  tz: 'TZS',
  ug: 'UGX',
  et: 'ETB',
  so: 'SOS',
  er: 'ERN',
  dj: 'DJF',
  mg: 'MGA',
  mu: 'MUR',
  re: 'EUR',
  yt: 'EUR',
  km: 'KMF',
  rw: 'RWF',
  bi: 'BIF',
  ss: 'SSP',
  sd: 'SDG',

  // Africa - Southern
  za: 'ZAR',
  zw: 'ZWG',
  zm: 'ZMW',
  mz: 'MZN',
  mw: 'MWK',
  bw: 'BWP',
  na: 'NAD',
  ls: 'LSL',
  sz: 'SZL',

  // Atlantic & Indian Ocean
  bm: 'BMD',
  gs: 'GBP',
  sh: 'SHP',
  sc: 'SCR',
  io: 'USD',
};
